import { SITE } from "@/data/content";
import { WhatsAppIcon } from "@/components/Shared";

const WhatsAppFloat = () => (
  <a
    href={SITE.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-button"
    className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_25px_rgb(0,0,0,0.25)] transition-transform duration-300 hover:scale-105"
  >
    <WhatsAppIcon className="h-6 w-6" />
    <span className="sr-only">Chat on WhatsApp</span>
  </a>
);

export default WhatsAppFloat;
